const getBreakpointNameByWidth = (width, breakpoints) => Object.keys(breakpoints).reduce((currentBreakpoint, breakpointName) => {
  const breakpoint = breakpoints[breakpointName];
  if (width >= breakpoint) {
    return breakpointName;
  }
  return currentBreakpoint;
});
const withinBreakpoint = function (min, max, breakpoints, currentBreakpoint) {
  let inclusive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  if (currentBreakpoint) {
    const minBreakpointSize = typeof min === 'string' ? breakpoints[min] : min;
    const maxBreakpointSize = typeof max === 'string' ? breakpoints[max] : max;
    const currentBreakpointSize = breakpoints[currentBreakpoint];
    if (inclusive) {
      return currentBreakpointSize >= minBreakpointSize && currentBreakpointSize <= maxBreakpointSize;
    }
    return currentBreakpointSize > minBreakpointSize && currentBreakpointSize < maxBreakpointSize;
  }
  return false;
};

export { getBreakpointNameByWidth, withinBreakpoint };
//# sourceMappingURL=breakpoints.js.map
